import "swiper/css/effect-coverflow";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Common_Title from "../../common/common-title/Common_Title";
import "./Moments_From_Workshop.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllMoments } from "../../../features/components/homepage/moments/Slice";
import { IDS } from "../../../utils/IDS";

import "swiper/css";

const images = [
  "/assets/images/home/moments/img-1.png",
  "/assets/images/home/moments/img-2.png",
  "/assets/images/home/moments/img-3.png",
  "/assets/images/home/moments/img-4.png",
  "/assets/images/home/moments/img-5.png",
  "/assets/images/home/moments/img-1.png",
];

const Moments_From_Workshop = () => {
  const dispatch = useDispatch();
  const moments = useSelector((state) => state?.homepage?.moments?.all_moments);

  useEffect(() => {
    dispatch(GetAllMoments());
  }, [dispatch]);

  return (
    <section className="Moments_From_Workshop">
      <div className="container">
        <Common_Title
          title="Moments from Our "
          subtitle="Counselling & Workshops"
        />

        <div className="image_slider_section">
          <Swiper
            effect={"coverflow"}
            centeredSlides={true}
            loop={true}
            slidesPerView={4}
            spaceBetween={50}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 25,
              },
              576: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 35,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 50,
              },
            }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            modules={[EffectCoverflow, Autoplay]}
            className="imageSwiper"
          >
            {moments?.map((img, index) => (
              <SwiperSlide key={index}>
                <div className="slide_img">
                  <img
                    src={IDS?.IMG_URL + img?.image}
                    alt="slide"
                    className="slide"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Moments_From_Workshop;
